<div class="alert alert-warning alert--small" *ngIf="filtering">
  You are seeing only {{ totalItems }} of {{ group.noticeCount }} occurrences
  that match your selected filters.
  <a
    class="alert-link"
    uiSref="groups-show"
    [uiParams]="{
      projectId: group.projectId,
      groupId: group.id,
      tab: 'notice-list'
    }"
    [uiOptions]="{ inherit: false, reload: true }"
    >Reset filters</a
  >
  to see all occurrences.
</div>
<div class="occurrence-header">
  <div class="occurrence-header__link">
    <button
      class="btn btn--link-color btn--no-shadow"
      (click)="toggleOccurrenceList()"
    >
      <i class="glyphicon glyphicon-angle-left occurrence-link__icon"></i>
      Back to Occurrence Detail
    </button>
  </div>
  <div class="occurrence-header__pager" *ngIf="totalItems > pageSize">
    <span class="occurrence-header__text">
      {{ pageStart }}-{{ pageEnd }} of {{ totalItems }}</span
    ><span class="btn-group">
      <button
        class="btn"
        type="button"
        (click)="fetchPage(totalPages)"
        [disabled]="!hasNextPage()"
      >
        <i class="glyphicon glyphicon-angle-double-left"></i>
      </button>
      <button
        class="btn"
        type="button"
        (click)="loadNextPage()"
        [disabled]="!hasNextPage()"
      >
        <i class="glyphicon glyphicon-angle-left"></i>
      </button>
      <button
        class="btn"
        type="button"
        (click)="loadPreviousPage()"
        [disabled]="!hasPreviousPage()"
      >
        <i class="glyphicon glyphicon-angle-right"></i>
      </button>
      <button
        class="btn"
        type="button"
        (click)="fetchPage(1)"
        [disabled]="!hasPreviousPage()"
      >
        <i class="glyphicon glyphicon-angle-double-right"></i></button
    ></span>
  </div>
</div>
<div class="row">
  <div class="col-lg-12">
    <div [hidden]="!loading">
      <ab-spinner></ab-spinner>
    </div>
    <hr [hidden]="loading" />
    <table class="ab-table" [hidden]="loading">
      <thead>
        <th class="ab-table__header"></th>
        <th class="ab-table__header">When</th>
        <th class="ab-table__header">Message</th>
        <th class="ab-table__header">Hostname</th>
        <th class="ab-table__header">Remote</th>
      </thead>
      <tbody>
        <tr
          class="ab-table__row ab-table__row--hoverable"
          *ngFor="let notice of notices; index as i; trackBy: trackBy"
          uiSref="notices-show"
          [uiParams]="{
            groupId: notice.groupId,
            noticeId: notice.id,
            tab: 'notice-detail'
          }"
          (mouseenter)="highlights[i] = 'ab-table__cell--underline'"
          (mouseleave)="highlights[i] = ''"
        >
          <td class="ab-table__cell text-small">
            <a
              uiSref="notices-show"
              [uiParams]="{ groupId: notice.groupId, noticeId: notice.id }"
              [ngClass]="highlights[i]"
              >{{ pageStart - i }}</a
            >
          </td>
          <td
            class="ab-table__cell ab-table__cell--when"
            *ngIf="activeNotice?.id !== notice.id"
          >
            {{ notice.createdAt | date: "MMM dd, y HH:mm:ss" }}
          </td>
          <td class="ab-table__cell" *ngIf="activeNotice?.id === notice.id">
            {{ notice.createdAt | date: "MMM dd, y HH:mm:ss" }}
          </td>
          <td class="ab-table__cell ab-table__cell--error-message">
            {{ notice.errors[0].message }}
          </td>
          <td class="ab-table__cell">{{ notice.context.hostname }}</td>
          <td class="ab-table__cell">{{ notice.context.remoteAddr }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
